import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ArticlesPreviewBlog.css';

const ArticlesPreview = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    axios.get('/api/taxiblogs')
      .then(response => setArticles(response.data))
      .catch(error => console.error('שגיאה בטעינת מאמרים:', error));
  }, []);

  return (
    <div className="ArticlesPreview-wrapper">
      <h2 className="ArticlesPreview-title-main">מגזין המוניות</h2>

      <div className="ArticlesPreview-container">
        {articles.slice(0, 8).map(article => (
          <div className="ArticlesPreview-card" key={article.id}>
            <img
              className="ArticlesPreview-image"
              src={`/public/uploads/TaxiBlogsImg/${article.id}.webp`}
              alt={article.alt_text || article.title}
            />
            <h3 className="ArticlesPreview-title">{article.title}</h3>
            <p className="ArticlesPreview-summary">{article.summary?.slice(0, 100)}...</p>
            <a
              className="ArticlesPreview-readMore"
              href={`/blog/${article.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              קרא עוד
            </a>
          </div>
        ))}
      </div>

<div className="ArticlesPreview-button-wrapper">
  <button
    className="hero-button"
    onClick={() => window.open('/BlogAndMagazine', '_blank')}
  >
    לכל המאמרים
  </button>
</div>

    </div>
  );
};

export default ArticlesPreview;
